<template>
    <div class="patient">
        <div class="account">
            <!-- Patient information -->
			<span class="name">
				<strong>{{ index }}. {{ patient.data.name }}</strong>
				<div v-if="patient.data.email" class="extra-info">
					{{ patient.data.email }}
				</div>
				<template v-if="patient.data.phone">
					<br><small>{{ patient.data.phone }}</small>
				</template>
			</span>

            <ol class="event-results" :class="rescheduleDataStatus.length > 1 ? 'multiple' : 'single'">
                <!-- Show the rescheduled event or an indication it will be a new event -->
                <li class="event-result"
                    v-for="(event, index) in rescheduleDataStatus"
                    :key="index">
                     <EventReschedule :event="event" :confirm="confirm" @create="createEvent" @reschedule="rescheduleEvent"></EventReschedule>
                </li>
            </ol>
        </div>
        <ImportData
			:patient="patient"
			:column="column"
			:highlight="['date', 'time', 'event', 'code', 'doctor']"
            :show-patient="rescheduleDataStatus">
		</ImportData>
    </div>
</template>

<script>
import Vue from 'vue'

import ImportPatientRow from '.'
import EventReschedule from './EventReschedule'

export default {
    name: 'import-patient-reschedule-row',
    extends: ImportPatientRow,

    data() {
        return {
            isReschedule: 'reschedule',
            confirmed: this.confirm !== true
        }
    },

    mounted() {
        if(!this.patient.rescheduleDefault) {
            Vue.set(this.patient.data, 'reschedule', (this.reschedule) ? this.rescheduleCopy() : [])
            Vue.set(this.patient, 'rescheduleDefault', true)
        }
        
    },

    computed: {
        reschedule() {
            return this.isReschedule === 'reschedule'
        },
        rescheduleDataStatus() {
            return this.patient.rescheduleData.map((event) => ({
                ...event,
                isReschedule: this.patient.data.reschedule ? this.patient.data.reschedule.some((rescheduleEvent) => rescheduleEvent.id === event.id) : false
            }))
        }
    },

    watch: {
        isReschedule() {
            if (this.confirmed)
                this.confirmed = false
        }
    },

    methods: {
        confirmEvent() {
            // TODO: does this work for multiple rescheduled events?
            Vue.set(this.patient.data, 'event', (this.reschedule) ? [] : this.rescheduleCopy())
            Vue.set(this.patient.data, 'reschedule', (this.reschedule) ? this.rescheduleCopy() : [])
            this.confirmed = true
        },
        rescheduleCopy() {
            if (this.patient.rescheduleData)
                return this.patient.rescheduleData.map((event) => ({
                    id: this.reschedule ? event.id : event.matchId,
                    match: event.match,
                    time: event.time,
                    provider: event.provider
                }))

            return []
        },
        createEvent(event) {
            const { id, matchId, time, match, provider } = event
            const removeIndex = this.patient.data.reschedule.findIndex((event) => event.id === id)
            if(removeIndex !== -1) {
                this.patient.data.reschedule.splice(removeIndex, 1)
            }
            this.patient.data.event.push({
                id: matchId,
                match: match,
                time: time,
                provider: provider
            })
        },
        rescheduleEvent(event) {
            const { id, matchId, time, match, provider } = event
            const removeIndex = this.patient.data.event.findIndex((event) => event.id === matchId && event.time === time)
            if(removeIndex !== -1) {
                this.patient.data.event.splice(removeIndex, 1)
            }
            this.patient.data.reschedule.push({
                id: id,
                match: match,
                time: time,
                provider: provider
            })
            this.isReschedule = 'reschedule'
        }
    },
    components: {
        EventReschedule
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
.event-results {
    list-style: none;
    margin-block-start: 0;
    &.multiple {
        counter-reset: event-counter;
        li.event-result {
            counter-increment: event-counter;
        }
        li.event-result::before {
            content: counter(event-counter, lower-alpha) ')';
            margin-right: 20px;
        }
    }
    .event-result {
        font-size: 14px;
    }
}

.confirm-event {
    margin-left: 20px;
    float: right;
}
</style>
<style scoped>
.event-choice >>> .el-switch__label{
    font-weight: 300;
    color: #bdc3c7;
}
.event-choice >>> .el-switch__label.is-active{
    font-weight: bold;
    color: #333;
}
</style>
